<template >
	<v-container>
    <v-snackbar
      v-model="snackbar"
      color="error"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
    >
      {{error}}
    </v-snackbar>
		<v-layout align-center wrap>
			<v-card width="100%" min-height="500px" light>
				<v-form
					ref="form"
					v-model="valid"
					lazy-validation
				>
				<v-card-title>
					<h1>{{$t('service.edition')}}</h1>
				</v-card-title>
				<v-card-text>
					<v-icon
						v-text="'highlight_off'"
						style="position:absolute; right:3px;top:3px;"
						@click="$router.push('/services')"
					></v-icon>
					<v-layout row wrap>
						<v-flex xs12 sm6 pa-2>
							<v-text-field filled :label="$t('service.title')"
								:rules="[rules.min4, rules.max500, rules.stringFormat, rules.required]"
								v-model="service.title"
							/>
							<v-select
								chips item-text=title item-value=id
								multiple filled :items="products" item
								:label="$t('service.selectedProducts')"
								v-model="service.products"
								:rules="[rules.min1element]"
							/>
							<v-select
								chips item-text=name item-value=id
								filled :items="concerns" item multiple
								:label="$t('service.selectedConcerns')"
								v-model="service.concerns"
								:rules="[rules.min1element]"
							/>
						</v-flex>
						<v-flex xs12 sm6 pa-2 justify-center>
							<v-text-field
								:rules="[rules.min4, rules.max500, rules.stringFormat]"
								:label="$t('global.shortDescription')"
								v-model="service.shortDescription" filled
							/>
							<v-textarea :rules="[rules.min4, rules.max500, rules.stringFormat]"
								auto-grow filled v-model="service.longDescription"
							>
								<div slot="label">{{$t('global.longDescription')}}</div>
							</v-textarea>
							<v-text-field filled :label="$t('global.durationMin')" type=number	v-model="service.duration"/>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-flex ma-3 text-center>
					<v-btn :disabled="!valid || disabled" @click="sendService">{{$t('global.send')}}</v-btn>
				</v-flex>
				</v-form>
			</v-card>
		</v-layout>
	</v-container>
</template>
<script>
import axios from 'axios'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl
var instance = axios.create({
  headers: { 'Authorization': 'Bearer ' + localStorage.token }
}); export default {
  props: ['id'],
  data () {
    return {
      snackbar: false,
      error: 'Error',
      disabled: false,
      valid: true,
      service: {
        'title': null,
        'longDescription': null,
        'shortDescription': null,
        'products': [],
        'concerns': [],
        'duration': 30,
      },
      rules: {
        min1element: value => !value || (!!value.length) || 'You need to select at least one element',
        min4: value => !value || (value.trim().length >= 4 || value.trim().length === 0) || 'Min 4 characters',
        max3: value => !value || value.trim().length <= 3 || 'Max 3 characters',
        max500: value => !value || value.trim().length <= 500 || 'Max 500 characters',
        max200: value => !value || value.trim().length <= 200 || 'Max 200 characters',
        max20: value => !value || value.trim().length <= 20 || 'Max 20 characters',
        stringFormat: value => {
          const correctStringReg = /^[a-zA-Z\d\r\n? .,'"%&:/_-]+$/
          return correctStringReg.test(value) || value === '' || 'Invalid Format'
        },
        eanFormat: value => {
          const correctStringReg = /^\w+$/
          return correctStringReg.test(value) || value === '' || 'Invalid Format'
        },
        urlFormat: value => {
          const correctStringReg = /^\w+$/
          return correctStringReg.test(value) || value === '' || 'Invalid Format'
        },
        required: value => !!value || 'Required.',
        string: value => typeof (value) === 'string' || 'Invalid Format'
      },
      faceTypesNames: [],
      faceTypes: [],
      products: [],
      concerns: [],
      imgsList: [],
      oldImg: null,
      currentImg: null,
      imgProgress: null,
      errors: []
    }
  },
  methods: {
    sendService: function () {
      if (!this.$refs.form.validate())
      {
        this.snackbar = true
        this.error = "Check your data format"
        return
      }
      this.disabled = true
      if (!this.id) {
        delete this.service.id
        instance.post('/' + this.$session.get('brand') + '/service',
          this.service,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(() => {
            this.$router.push('/services')
          })
          .catch((error) => {
            this.snackbar = true
            this.error = 'Your Service could not be create'
            this.disabled = false
            this.errors.push(error)
          })
      } else {
        delete this.service._id
        delete this.service.medias
        instance.put('/' + this.$session.get('brand') + '/service/' + this.id,
          this.service,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(() => {
            this.$router.push('/services')
          })
          .catch(() => {
            this.snackbar = true
            this.error = 'Your service could not be edited'
          })
      }
    },
    eanToName: function (value) {
      var output = null
      this.products.forEach(function (element) {
        if (value === element.ean) { output = element.title }
      })
      return (output)
    },
    deleteImg: function (id) {
      this.imgsList.splice(id, 1)
      this.service.packshots.splice(id, 1)
    },
    openImgUpload: function () { this.$refs.image.click() }
  },
  created () {
    if (this.id) {
      instance.get('/' + this.$session.get('brand') + '/service/' + this.id)
        .then(response => {
          this.service = response.data.data[0].service[0]
          this.service.longDescription = this.service.description.long
          this.service.shortDescription = this.service.description.short
          delete this.service.description
        })
        .catch(() => this.$router.push('/error'))
    }
    instance.get('/' + this.$session.get('brand') + '/products')
      .then(response => {
        this.products = response.data.data[0].products
        this.products.forEach(function (element) {
          element.title = element.title['en-US']
        })
      })
      .catch(() => this.$router.push('/error'))
    instance.get('/' + this.$session.get('brand') + '/concerns')
      .then(response => {
        this.concerns = response.data.data[0].concerns
        this.concerns.forEach(function (element) {
          element.name = element.name['en-US']
        })
      })
      .catch(() => this.$router.push('/error'))
    instance.get('/' + this.$session.get('brand') + '/service/medias')
      .then(response => {
        this.faceTypes = response.data.data[0].medias
        Object.keys(response.data.data[0].medias).forEach((element) => {
          this.faceTypesNames.push(element)
        })
      })
      .catch(() => this.$router.push('/error'))
  }
}
</script>

<style>
</style>
